/**
 * Utility Functions
 */
export const isMobile = () => window.matchMedia('(max-width: 768px)').matches;
export function delegateEvent(element, eventType, selector, handler) {
    if (!element)
        return;
    element.addEventListener(eventType, (e) => {
        const target = e.target.closest(selector);
        if (target) {
            handler(e, target);
        }
    });
}
export function createElement(tag, className, attributes = {}, innerHTML = '') {
    const el = document.createElement(tag);
    if (className)
        el.className = className;
    Object.entries(attributes).forEach(([key, value]) => el.setAttribute(key, value));
    if (innerHTML)
        el.innerHTML = innerHTML;
    return el;
}
